/* eslint-disable @angular-eslint/component-class-suffix */
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService } from '@migo-apps/dialogs';
import { finalize } from 'rxjs';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@migo-apps/components';
import { BreakpointService } from '../../../shared/services/breakpoint/breakpoint.service';

const EMAIL_REQUIRED_TITLE = 'AUTH.DIALOG.RESET-PASS.EMAIL-REQUIRED-TITLE';
const BAD_EMAIL_MESSAGE = 'AUTH.DIALOG.RESET-PASS.BAD-EMAIL-MESSAGE';

/**
 *Pagina para solicitar un reestablecimiento de contraseña
 *
 * @export
 * @class RestorePasswordPage
 */
@Component({
  standalone: false,
  selector: 'migo-apps-restore-password',
  templateUrl: './restore-password.page.html',
  styleUrls: ['./restore-password.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestorePasswordPage implements OnInit {
  recoveryForm!: FormGroup;
  loading = false;

  constructor(
    private builder: FormBuilder,
    private dialogSvc: DialogService,
    private authSvc: AuthenticationService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private i18n: TranslateService,
    private toastService: ToastService,
    public bp: BreakpointService
  ) {}
  ngOnInit(): void {
    this.createForm();
  }

  /**
   * If the email is invalid, show an error message. Otherwise, send a password reset
   * request to the server
   * @returns a void.
   */
  onSubmit(): void {
    if (this.recoveryForm.invalid) {
      this.i18n
        .get([EMAIL_REQUIRED_TITLE, BAD_EMAIL_MESSAGE])
        .subscribe((value) => {
          this.dialogSvc.openInformationDialog({
            title: value[EMAIL_REQUIRED_TITLE],
            message: value[BAD_EMAIL_MESSAGE],
          });
        });
      this.recoveryForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    const emailValue = this.recoveryForm.value.email;

    this.authSvc
      .sendPasswordResetRequest(emailValue)
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cd.markForCheck();
        })
      )
      .subscribe({
        next: () => {
          this.router.navigate(['auth', 'validate-otp'], {
            queryParams: { email: emailValue },
            queryParamsHandling: 'merge',
          });
        },
        error: () => {
          this.toastService.toast(
            'Ingresa el correo asociado a tu<br />cuenta para recuperar tu contraseña'
          );
        },
      });
  }

  private createForm() {
    this.recoveryForm = this.builder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }
}
